//Navigation
!function (i) { i.fn.menumaker = function (n) { var e = i(this), s = i.extend({ title: "Menu", format: "language-changer", sticky: !1 }, n); return this.each(function () { return e.find("li ul, li .mega-dropdown").parent().addClass("has-sub"), multiTg = function () { e.find(".has-sub").prepend('<button class="submenu-button"  aria-expanded="true" aria-label="sub menu"></button>'), e.find(".submenu-button").on("click", function () { $(i(this)).text(($(i(this)).text() == '') ? i(this).next().text() : ''); i(this).toggleClass("submenu-opened"), i(this).parent().toggleClass("parent-active"), i(this).siblings("ul,.mega-dropdown").hasClass("open") ? i(this).siblings("ul,.mega-dropdown").removeClass("open").hide() : i(this).siblings("ul,.mega-dropdown").addClass("open").show() }) }, "multitoggle" === s.format ? multiTg() : e.addClass("language-changer"), s.sticky === !0 && e.css("position", "fixed"), resizeFix = function () { i(window).width() > 1024 && e.find("ul,.mega-dropdown").show(), i(window).width() <= 1024 && e.find("ul,.mega-dropdown").hide().removeClass("open") }, function () { $(window).width() > 1024 ? (resizeFix("resize"), i(window).on(resizeFix)) : (resizeFix(), i(window).on(resizeFix)) } }) } }($), function (i) { i(document).ready(function () { $(".mega-dropdown").parent().addClass("has-mega"), i("#sidebar-nav").menumaker({ title: "", format: "multitoggle" }) }) }(jQuery);
// For small screen Nav
jQuery(document).click(function (a) {
  var f = jQuery(a.target).closest(".nav-trigger"), g = jQuery(a.target).closest("#sidebar-nav"); f.length ? (a.preventDefault(), jQuery("html").toggleClass('sidebar_active'), jQuery(".nav-trigger").toggleClass("closemenu")) : g.length || (jQuery("html").removeClass('sidebar_active'), jQuery(".nav-trigger").removeClass("closemenu"))
});
// For menu position
function isTouchDevice() { return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch); } if (isTouchDevice() === true) { } else { jQuery(window).on('load', function () { setTimeout(function () { jQuery("ul.nav > li.has-sub").hover(function () { var s = jQuery("header").offset(), t = jQuery("header").width(), e = s.left + t, i = jQuery(this).find(".submenu-button").siblings("ul").offset(), n = jQuery(this).find(".submenu-button").siblings("ul").width(); e < i.left + n && jQuery(this).addClass("align-left-menu") }, function () { jQuery(this).removeClass("align-left-menu") }), jQuery("ul.nav ul li.has-sub").hover(function () { var s = jQuery("header").offset(), t = jQuery("header").width(), e = s.left, i = e + t, n = jQuery(this).find(".submenu-button").siblings("ul").offset(), l = jQuery(this).find(".submenu-button").siblings("ul").width(), u = n.left; i < u + l && (jQuery(this).addClass("align-left-menu")), e > u && jQuery(this).addClass("align-right-menu") }, function () { jQuery(this).removeClass("align-left-menu"), jQuery(this).removeClass("align-right-menu") }), jQuery(".nav-wrap nav ul.nav ul .has-sub").each(function (iz) { jQuery(this).css("z-index", "500" - iz); }); }, 200); }); }
navFuc = function () {
  $(".nav-wrap nav ul.nav > li").each(function () {
    // wheight=$( window ).height();
    wwidth = $(window).width();
    pwidth = $("header .container").width();
    dwidth = wwidth - pwidth;
    thewidth = dwidth / 2;
    thePos = $(this).offset().left - thewidth;
    $(this).find(".mega-dropdown").css("left", - thePos)
    $(".mega-dropdown").css("width", pwidth);
    // $(".nav-wrap .mega-dropdown").css("height",wheight);
    //    $(".nav-wrap nav ul.nav ul").css("height",wheight);
  });
};
$(".nav-wrap nav ul.nav > li  ul>li").hover(function () {
  $(this).parent().find("li").removeClass("active");
  $(this).addClass("active");
});
$(document).ready(function () {
  navFuc();
  setTimeout(function () {
    navFuc();
  }, 300);
});
$(window).resize(function () {
  navFuc();
  setTimeout(function () {
    navFuc();
  }, 300);
});

$(".nav-wrap nav ul.nav > li.click-nav > a").on("click", function () {
  $(this).parent().find("li").removeClass("mega-active");
  $(this).parent().addClass("mega-active");
});
$(".nav-wrap nav ul.nav > li.click-nav").on("mouseleave", function () {
  $(".click-nav").removeClass("mega-active");
});

//Navigation End
// Header Shrink
$(function () { function b() { return window.pageYOffset || document.documentElement.scrollTop } $(window).scroll(function () { b() >= 50 ? ($("html").addClass("head-fix")) : ($("html").removeClass("head-fix")) }) });
// Header Shrink End
// scroll up
jQuery(window).scroll(function () { jQuery(this).scrollTop() > 400 ? jQuery(".scrollup").addClass("show") : jQuery(".scrollup").removeClass("show") }), jQuery(".scrollup").click(function () { return jQuery("html, body").animate({ scrollTop: 0 }, 500), !1 });
// Scroll Top Js
var offset = 0, duration = 500; $(window).scroll(function () { $(this).scrollTop() > offset ? $(".scrollup").fadeIn() : $(".scrollup").fadeOut() }), $(".scrollup").click(function (a) { return a.preventDefault(), $("html, body").animate({ scrollTop: 0 }, duration), !1 });
// Click Dropdown
$(document).on('click touchstart', function (fd) {
  var click_box = $(".search-triger, .search-block");
  if (!click_box.is(fd.target) && click_box.has(fd.target).length === 0) {
    jQuery('.search-triger').removeClass("active");
    jQuery(".search-block").hide();
  }
});
//Search
jQuery('.search-triger').click(function () {
  jQuery(this).toggleClass("active");
  jQuery(".search-block").fadeToggle();
});
// class adding in image
$(".alignright,.alignleft").closest("p").addClass("pn")
// Background set
$(".bg img").each(function (da) { var db = $(this).attr("src"); $(this).parent().css("background-image", "url(" + db + ")") });
// Table wrap
$("table").wrap("<div class='table-responsive'></div>");
//Devicewidth
function minus_margin() {
  ww = $(window).width();
  cw = $("header .container").outerWidth();
  dcw = ww - cw;
  doww = dcw / 2 + 15;
  jQuery(".minus-right").css('margin-right', -doww);
  jQuery(".minus-left").css('margin-left', -doww);
}
minus_margin();
jQuery(window).resize(function () {
  minus_margin();
});
// Smooth scroll
$('.smooth, ul.nav li a').click(function (event) {
  if (
    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
    && location.hostname == this.hostname
  ) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    if (target.length) {
      event.preventDefault();
      $('html, body').animate({
        scrollTop: target.offset().top - 84
      }, 500);
    }
  }
});
//Sidbar
jQuery('.small-icon-trigger').click(function () {
  jQuery(this).toggleClass("active");
  jQuery(this).next().slideToggle();
});
jQuery('.filter-trigger').click(function () {
  jQuery(this).toggleClass("active");
  jQuery("html").toggleClass("overlay-black");
  jQuery(this).next().toggleClass("active");
});
//Aside Filter
$('.all-open .filter-head').addClass('active');
$('.all-open .filter-content').slideDown().addClass('active');
$('.first-open .filter-head:first-of-type').addClass('active');
$('.first-open .filter-content:first-of-type').slideDown().addClass('active');
$('.filter-head').click(function () {
  $(this).toggleClass('active');
  $(this).next('.filter-content').slideToggle().toggleClass('active');
});
//Show Hide By Anchor
$('.anchor-click a').click(function (e) {
  e.preventDefault();
  var $box = $('.anchor-box');
  var headerHeight = $('header').outerHeight();
  if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') &&
    location.hostname === this.hostname) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    if (target.length) {
      var id = this.hash;
      $(".anchor-click a").each(function () {
        if ($(this).attr("href") === id) {
          $(this).addClass("active");
        } else {
          $(this).removeClass("active");
        }
      });
      $box.not(id).stop().hide().removeClass("active");
      $(id).fadeIn().addClass("active");
      $('html, body').animate({
        scrollTop: target.offset().top - headerHeight
      }, 1000);
      return false;
    }
  }
});



$('.side-category-slider + .category-content p:empty, .side-heading-block p:empty').remove();
// Accordian
$('.all-faq:first-of-type .accordion-data:first-of-type .accordion-head').addClass('active');
$('.all-faq:first-of-type .accordion-data:first-of-type .accordion-content').slideDown().addClass('active');
$('.accordion-data').click(function () {
  if ($(this).children('.accordion-content').hasClass("active")) {
    $(this).removeClass('active');
    $(this).children('.accordion-head').removeClass('active');
    $(this).children('.accordion-content').slideUp().removeClass('active');
  } else {
    $(this).parent().find(".accordion-head").removeClass('active');
    $(this).parent().find('.accordion-data').removeClass('active');
    $(this).parent().find('.accordion-content').slideUp().removeClass('active');
    $(this).children('.accordion-head').addClass('active');
    $(this).children('.accordion-content').slideDown().addClass('active');
    $(this).addClass('active');
  }
});
$('[id^="step-"]').hide();
$('#step-1').show();
$('[id^="go-"]').on('click', function (e) {
  e.preventDefault();
  const currentStep = parseInt(this.id.split('-')[1]);
  const nextStep = currentStep + 1;
  $('[id^="step-"]').slideUp();
  $(`#step-${nextStep}`).slideDown();
  $('ul#steps li').removeClass('active complete');
  for (let i = 1; i <= nextStep; i++) {
    $(`ul#steps li:nth-child(${i})`).addClass('active complete');
  }
  $('html, body').animate({
    scrollTop: $('#steps').offset().top - 170
  }, 1000);
});
jQuery(function ($) {
  // Touch Device Detection
  var isTouchDevice = 'ontouchstart' in document.documentElement;
  if (isTouchDevice) {
    $('body').addClass('touch');
  }
});
jQuery('input[type="radio"]').click(function () {
  var inputValue = jQuery(this).attr("value");
  if (inputValue == "experience") {
    jQuery(".experience").show();
    jQuery(".startup").hide();
  }
  if (inputValue == "startup") {
    jQuery(".startup").show();
    jQuery(".experience").hide();
  }
});

$('.xzoom-gallery').on('click', function () {
  $('.xzoom-large .image-thumbnail').removeClass('video-active');
  $('.xzoom-large .image-thumbnail iframe').remove();
});

document.querySelectorAll('.video-slide').forEach(slide => {
  slide.addEventListener('click', function () {
    let videoContainer = document.querySelector('.xzoom-large .image-thumbnail');
    let existingVideo = videoContainer.querySelector('iframe');
    if (existingVideo) existingVideo.remove();
    $('.xzoom-large .image-thumbnail').addClass('video-active');
    let youtubeEmbedUrl = this.getAttribute('data-video');
    let iframe = document.createElement('iframe');
    iframe.src = youtubeEmbedUrl + '?autoplay=1&mute=1&rel=0';
    iframe.width = "100%";
    iframe.height = "100%";
    iframe.frameBorder = "0";
    iframe.allow = "autoplay; encrypted-media";
    iframe.allowFullscreen = true;
    videoContainer.appendChild(iframe);
  });
});
